import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { AppSettings } from '../../app.settings';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { UiService } from '../../services/ui.service';
import { Grid2Model } from './grid-2-model';
import { Grid2Service } from './grid2.service';

@Component({
  selector: 'app-mi-grid-v2',
  providers: [Grid2Service],
  templateUrl: './mi-grid-2.component.html'
})

export class MiGrid2Component implements OnInit, OnDestroy {
  subscription: Subscription;
  rowData: any[] = [];
  search = '';
  @Output() rowClickedEvent = new EventEmitter<any>();
  @Output() totalCount = new EventEmitter<any>();
  @Output() actionBtnClickedEvent = new EventEmitter<any>();
  @Output() getGridReference: EventEmitter<any> = new EventEmitter();
  @Output() searchTextgrd = new EventEmitter<any>();
  @Output() paginationEmmiter = new EventEmitter<any>();
  @Input() url: any = '';
  @Input() bottomSearchBar = false;
  @Input() isDetailScreen: Boolean;
  @Input() bottomExportButton = false;
  @Input() actionWidth = 130;
  @Input() rowSelection = 'single';
  @Input() printUrl: any = '';
  @Input() exportUrl: any = '';
  @Input() exportCSVUrl: any = '';
  @Input() columnDefs: any[] = [];
  @Input() actionButtonsDefs: any[] = [];
  @Input() eSignButtonsDefs: any[] = [];
  @Input() pagination: any = true;
  @Input() paginationPageSize: any = 15;
  @Input() paginationStartPage: any = 0;
  @Input() defaultSortField = '';
  @Input() divClass = '';
  @Input() placeholderValue = 'Press enter to search';
  @ViewChild('dt') dt: Table;
  @Input() staticGridData = [];
  @Input() isPasteEnabled = false;
  @Input() gridType;
  queryParams: any = '';
  gridUrlParams: any = '';
  enableResizer = 'false';
  @Input() overlayLoadingTemplate: any = '<span class="ag-overlay-loading-center b-red">' +
    'Please wait while your rows are loading</span>';
  datasource = [];
  model: Grid2Model;
  totalRecords = 0;
  sortF = '';
  first: any = 0;
  sortO = '';
  offset = 0;
  setRowLength = 10;
  searchText = '';
  selectedRecords: any = [];
  constructor(private elm: ElementRef, private uiService: UiService, private gridService: Grid2Service, private router: Router,
    private commonBindingService: CommonBindingDataService
  ) { }

  ngOnInit() {
    window['page'] = this;
    this.subscription = this.uiService.sidebarToggledEvent
      .subscribe((state: string) => {
        this.refreshList();
      });
  }

  onResize(event: any) {
    // this.refreshList();
  }

  refreshList() {
    this.fetchAndLoadData();
  }

  fetchAndLoadData(customOffset?) {
    const that = this;
    this.gridService.loadGridData(that.getUrl(that.url, customOffset)).subscribe(result => {
      const model = <Grid2Model>result;
      if (result !== undefined) {
        this.totalRecords = model.count;
        that.datasource = [];

        if (this.staticGridData.length > 0) {
          model.data = this.staticGridData;
        }

        model.data.forEach(e => {
          that.columnDefs.forEach(c => {
            if (c && c.cellRenderer) {
              e[c.field] = c.cellRenderer(e[c.field]);
            } else if (c && c.cellRendererHtml) {
              e[c.field] = c.cellRendererHtml(e);
            }

            // that.actionButtonsDefs.forEach(d => {
            //   if (d.show) {
            //     e[d.field] = d.show(e);
            //   }
            // });

            that.actionButtonsDefs.forEach(d => {
              if (d.show) {
                e[d.field] = d.show(e);
              }
              if (d.title) {
                e[d.title] = d.title(e);
              }
            });
          });
          if (this.eSignButtonsDefs.length > 0) {
            const dispatchIdBtn = this.eSignButtonsDefs.find(btn => btn.class === 'dispatchId');
           // const esignBtn = this.eSignButtonsDefs.find(btn => btn.class === 'ESIGN');
            e['ESIGN'] = `
              ${dispatchIdBtn?.show(e) || ''}`;
          }
          that.datasource.push(e);
        });
      }
      this.totalCount.emit(this.totalRecords);
      this.getPaginationOffset();
    });
  }

  paginate(event) {
    console.log('event', event);
    this.first = event.first;
    this.paginationEmmiter.emit({first: event.first, rows: event.rows});
  }

  getUrl(url, customOffset?) {
    const that = this;
    let params = 'searchText=' + this.searchText + '&offset=' +
    (customOffset ? customOffset : this.offset) + '&limit=' + this.setRowLength;
    params += '&sortColumn=';
    params += this.sortF;
    params += '&sortType=';
    params += this.sortO;
    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }

    if (this.url.lastIndexOf('?') < 0) {
      this.gridUrlParams = '';
    } else {
      this.gridUrlParams = this.url.substring(this.url.lastIndexOf('?'));
      this.gridUrlParams = this.gridUrlParams.replace('?', '&');
    }

    buildUrl += params;
    return buildUrl;
  }

  getPaginationOffset() {
    let paginationOffset;
    this.commonBindingService.paginationPayload.subscribe((res) => {
      paginationOffset = res;

    });
    if (paginationOffset !== null && paginationOffset.gridType === this.gridType) {
      this.loadDatasourceLazy({}, paginationOffset.paginationStart);
      setTimeout(() => {
        if (paginationOffset) {
          this.dt.first = paginationOffset.paginationStart;
          this.commonBindingService.paginationPayload.next(null);
        }

      }, 100);
    } else {
      this.dt.first = this.offset;
    }
  }

  public onQuickFilterChanged($event, dt) {
    if ($event.key === 'Enter') {
        this.search = this.search.trim();
        this.search = this.search.replace(/\s{2,}/g, ' ');
        this.applySearch(this.search);
        dt.first = 0;
        this.searchTextgrd.emit(this.search);
    }
  }

  keyPress($event) {
    const invalidKeys = AppSettings.NOT_ALLOWED_KEYS;
    if (invalidKeys.indexOf($event.key) !== -1) {
      return false;
    }
  }

  updateUrl(url: string) {
    this.url = url;
    this.offset = 0;
    this.first = 0;
    const paramArray: any[] = this.url.split('?');
    if (paramArray.length > 1) {
      this.queryParams = paramArray[1];
    } else {
      this.queryParams = '';
    }
    this.refreshList();
  }

  updateData(url: string) {
    this.url = url;
    const paramArray: any[] = this.url.split('?');
    if (paramArray.length > 1) {
      this.queryParams = paramArray[1];
    } else {
      this.queryParams = '';
    }
    this.refreshList();
  }

  loadDatasourceLazy(event: LazyLoadEvent, customOffset?) {
    this.sortF = this.defaultSortField;
    this.offset = customOffset ? customOffset : event.first;
    this.first = event.first ? event.first : this.first;
    this.setRowLength = event.rows ? event.rows : 15;
    if (event.sortField !== undefined) {
      this.sortF = event.sortField;
    }
    this.sortO = event.sortOrder > 0 ? 'asc' : 'desc';
    this.fetchAndLoadData();
  }

  onRowSelect(event) {
    this.rowClickedEvent.emit(event);
  }

  onRowUnselect(event) {
  }


  actionBtnClick(event, data: any, action: string) {
    event.stopPropagation();
    const obj = { row: data, class: action };
    this.actionBtnClickedEvent.emit(obj);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSelectedRecords() {
    return this.selectedRecords;
  }

  applySearch(searchText: string) {
    this.searchText = searchText;
    this.offset = 0;
    this.first = 0;
    this.fetchAndLoadData();
  }

  isDateOlderThan180Days(dateStr: any) {
    let inputDate: Date;

    if (typeof dateStr === 'string' && dateStr.includes('/')) {
      const [month, day, year] = dateStr.split('/');
      inputDate = new Date(`${year}-${month}-${day}`);
    } else if (!isNaN(dateStr)) {
      inputDate = new Date(Number(dateStr));
    } else {
      return false;
    }

    const pastLimit = new Date();
    pastLimit.setDate(pastLimit.getDate() - 180);

    return inputDate < pastLimit;
  }


  checkDateFromUrl(url: any) {
    console.log('url', url);
    const params = new URLSearchParams(url.split('?')[1] || url.split('&').slice(1).join('&'));
    const fromDateStr = params.get('fromDateStr');
    const toDateStr = params.get('toDateStr');

    const isFromDateOld = this.isDateOlderThan180Days(fromDateStr);
    const isToDateOld = this.isDateOlderThan180Days(toDateStr);

    if (isFromDateOld || isToDateOld) {
      return true;
    } else {
      return false;
    }
  }

  exportGridExcel(event: any) {
    const that = this;
    if (this.checkDateFromUrl(that.exportUrl + this.gridUrlParams)) {
      this.gridService.downloadExcelGridData(that.getUrlExport(that.exportUrl) + this.gridUrlParams + '&legacy=true');
    } else {
      this.gridService.downloadExcelGridData(that.getUrlExport(that.exportUrl) + this.gridUrlParams);
    }
    // this.gridService.downloadExcelGridData(that.getUrl(that.exportUrl + '?' + this.searchText + '&' + this.queryParams));
    // this.gridService.downloadExcelGridData(that.getUrlExport(that.exportUrl) + this.gridUrlParams);

  }

  exportGridPdf(event: any) {
    const that = this;
    this.gridService.downloadPdfGridData(that.getUrl(that.printUrl + '?' + this.searchText + '&' + this.queryParams));
  }

  getTitle(value) {
    if (value.title) {
     return value.title;
    } else if (value.innerHTML) {
      return value.innerHTML.replace('<br>', ', ');
    } else {
      return value;
    }
     }

  getDropdownColor(rowData) {
    if (this.router.url === '/dispatch-request/dispatch-request-listview') {
      if (rowData.dispatchStatusId === 510) {
        return 'bg-request-new';
      } else if (rowData.dispatchStatusId === 520) {
        return 'bg-request-dispatch-assigned';
      } else if (rowData.dispatchStatusId === 530) {
        return 'bg-request-accepted';
      } else if (rowData.dispatchStatusId === 560) {
        return 'bg-request-enroute';
      } else if (rowData.dispatchStatusId === 570) {
        return 'bg-request-cancelled';
      } else if (rowData.dispatchStatusId === 580) {
        return 'bg-request-onscene';
      } else if (rowData.dispatchStatusId === 590) {
        return 'bg-request-completed';
      } else if (rowData.dispatchStatusId === 600) {
        return 'bg-request-dispatch-completed';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getUrlExport(url) {
    const that = this;
    let params = 'searchText=' + this.search;
    params += '&sortColumn=';
    params += this.sortF;
    params += '&sortType=';
    params += this.sortO;
    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }
    if (this.url.lastIndexOf('?') < 0) {
      this.gridUrlParams = '';
    } else {
      this.gridUrlParams = this.url.substring(this.url.lastIndexOf('?'));
      this.gridUrlParams = this.gridUrlParams.replace('?', '&');
    }
    buildUrl += params;
    return buildUrl;
  }

  onPaste(event: ClipboardEvent) {
    if (!this.isPasteEnabled) {
      event.preventDefault();
    }

  }
}
